/** 展立超频模式开关 */
import React from "react";
import { useTranslation } from "react-i18next";
import { Iconfont, Switch, Tooltip } from "@eweadn-qiankun/shared-components";
import "./ZhanliOverclockSwitch.scss";

interface ZhanliOverclockSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

const ZhanliOverclockSwitch: React.FC<ZhanliOverclockSwitchProps> = ({
  checked,
  onChange,
  disabled = false,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={`zhanli-overclock-switch${checked ? " zhanli-overclock-switch--active" : ""}`}
    >
      <span className="zhanli-overclock-switch__label">
        {t("mouse.performance.fps20kOverclockMode")}
        <Tooltip
          text={t("mouse.parameter.fps20kScanDesc")}
          placement="bottom"
          maxWidth={244}
          usePortal
          overlayClassName="zhanli-overclock-switch__tooltip"
        >
          <span
            className="zhanli-overclock-switch__info"
            aria-label={t("mouse.parameter.fps20kScanDesc")}
          >
            <Iconfont icon="information" />
          </span>
        </Tooltip>
      </span>
      <Switch checked={checked} disabled={disabled} onChange={onChange} />
    </div>
  );
};

export default ZhanliOverclockSwitch;
